<template>
  <div class="activity">

    <div class="add-box">
     

         <!-- <baidu-map class="map" :center="{lng: 113.308052, lat: 23.088793}" :zoom="15">
          <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
            <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">我爱北京天安门</bm-info-window>
          </bm-marker>

          <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
            <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">我爱北京天安门</bm-info-window>
          </bm-marker>
        </baidu-map> -->

        <baidu-map class="map" :center="{lng: 113.3209, lat: 23.1326}" :zoom="20">
      

          <!-- <bm-marker :position="{lng: 113.3209, lat: 23.1326}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
            <bm-label content="" :labelStyle="{color: 'red', fontSize : '24px'}"  :offset="{width: -35, height: 30}"/>
          </bm-marker> -->
          <bm-marker :position="{lng: 113.3209, lat: 23.1326}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" :icon="{url: 'https://sz-yptx.oss-cn-shenzhen.aliyuncs.com/things/prod/20220524/yly.png', size: {width: 40, height: 40}}"></bm-marker>
        </baidu-map>

   
    </div>
    


      <div class="column-wrap">
        <div class="column-box">
          <div class="solve-box clearfix">
            <div class="solve-list fl">
              <div class="solve-img">
                <img src="../assets/contact1.png" alt="">
              </div>
              <div class="solve-text">
                <div>
                  咨询服务
                </div>
                <div>
                  <span>
                    18122733881
                  </span>
                </div>
              </div>
            </div>
            <div class="solve-list fl">
              <div class="solve-img">
                <img src="../assets/contact2.png" alt="">
              </div>
              <div class="solve-text">
                <div>
                  公司邮箱
                </div>
                <div>
                  charlymix@qq.com
                </div>
              </div>
            </div>
            <div class="solve-list fl">
              <div class="solve-img">
                <img src="../assets/contact3.png" alt="">
              </div>
              <div class="solve-text">
                <div>
                  公司地址
                </div>
                <div>
                  广州市越秀区富力新天地中心3011室
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-wrap">
        <div class="contact-box">
          <img src="../assets/contact4.png" alt="">
        </div>
        <div class="contact-text">
          <div>
            不管您有任何疑问，都可以随时联系我们！
          </div>
          <div>
            物联平台在收到您的邮件后会尽快给您回复，感谢支持
          </div>
        </div>
      </div>


      <div class="contact-form ">
        <div class="form-box clearfix">
          <div class="input-list fl">
            <input type="text" placeholder="姓名">
          </div>
          <div class="input-list fl">
            <input type="text" placeholder="电话">
          </div>
          <div class="input-list fl">
            <input type="text" placeholder="邮箱">
          </div>
        </div>
        <div class="message-box">
          <textarea placeholder="留言" name="" id="" cols="30" rows="10"></textarea>
        </div>
        <div class="btn-box">
          <button>确认提交</button>      
        </div>
      </div>
      



  </div>
</template>
<script>
import {BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker} from 'vue-baidu-map'
  export default {
    name: "activity",
    data(){
      return{
        showMapComponent: this.value,
        keyword: '',
        mapStyle: {
          width: '100%',
          height: this.mapHeight + 'px'
        },
        center: {lng:"", lat: ""},
        zoom: 20,
        mapKey:false,
      }
    },
     components: {
      BaiduMap,
      BmControl,
      BmView,
      BmAutoComplete,
      BmLocalSearch,
      BmMarker
    },
    mounted(){
      


    },
    methods:{

      // getClickInfo (e) {
      //   this.center.lng = e.point.lng
      //   this.center.lat = e.point.lat
      // },
      // syncCenterAndZoom (e) {
      //   const {lng, lat} = e.target.getCenter()
      //   this.center.lng = lng;
      //   this.center.lat = lat;
      //   this.zoom = e.target.getZoom()
      // },
      // keepMap(){
      //   this.ruleForm.longitude = this.center.lng;
      //   this.ruleForm.latitude = this.center.lat;
      //   this.mapKey = false;
      // }
      infoWindowClose () {
      this.show = false
    },
    infoWindowOpen () {
      this.show = true
    }

    },
    created:function(){
    },
    watch:{
    },
  }
</script>

<style scoped>
.add-box{
  height: 400px;
  overflow: hidden;
}
.map{
  height: 100%;
}
.column-box{
  padding: 0 30px;
  box-sizing: border-box;
  width: 1160px;
  margin: 50px auto 0;
}
.solve-list{
		margin-bottom: 50px;
		width: 33.3333%;
		text-align: center;
	}
	
	.solve-img{
		width: 70px;
		display: inline-block;
	}
	.solve-img img{
		display: block;
		width: 100%;
	}
.solve-text div{
  font-size: 18px;
  /* display: inline-block; */
  margin-top: 10px;
}
.solve-text div:nth-child(1){
  font-size: 24px;
  color: #111111;
}
.solve-text div:nth-child(2){
  font-size: 18px;
  color: #555555;
}

.swiper-icon{
  width: 100px;
  margin: 0 auto;
}
.swiper-icon img{
  display: block;
  width: 100%;
}
.swiper-title{
  text-align: center;
  font-size: 28px;
  color: #000000;
  margin-bottom: 40px;
}
.swiper-text{
  text-align: center;
  font-size: 24px;
  color: #666666;
  width: 75%;
  margin: 0 auto;
}

.contact-wrap{
  width: 460px;
  text-align: center;
  margin: 0 auto;
}
.contact-box{
  width: 260px;
  display: inline-block;
  margin-bottom: 40px;
}

.contact-text{
  font-size: 18px;
  color: #7D7D7D;
}
.contact-text div:nth-child(1){
  margin-bottom: 10px;
}
.contact-form{
  width: 1160px;
  margin: 50px auto 108px;
}
.form{
  width: 100%;
}

.input-list{
  width: 33.3333%;
  padding: 10px;
}
.input-list input{
  display: block;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding-left: 40px;
  cursor: pointer;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
}
.input-list:nth-child(1) input{
  background: url(../assets/c1.png) 10px center no-repeat;
  background-size: 24px;
  background-color: #fff;
}
.input-list:nth-child(2) input{
  background: url(../assets/c2.png) 10px center no-repeat;
  background-size: 24px;
  background-color: #fff;
}
.input-list:nth-child(3) input{
  background: url(../assets/c3.png) 10px center no-repeat;
  background-size: 24px;
  background-color: #fff;
}
.message-box {
  padding:0 10px;
}
.message-box textarea{
  width: 100%;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 15px 40px;
  background: url(../assets/c4.png) 10px 10px no-repeat;
  background-size: 24px;
  background-color: #fff;
}
.btn-box{
  width: 100%;
}
.btn-box button{
  width: 220px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #3575E1;
  border: 1px solid #3575E1;
  color: #fff;
  margin: 50px auto 0; 
  font-size: 20px;
  display: block;
  border-radius: 8px;
}
.btn-box button:hover{
  border: 1px solid #3575E1;
  color: #3575E1;
  background: none;
}


</style>






// WEBPACK FOOTER //
// src/components/activity.vue